@if (isLoading$ | async) {
  <div class="overlay"></div>
  <div class="loader"></div>
}
